import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const gpt3Logo = 'https://cdn.snageasy.in/app-img/webp/assets/logonsm.webp';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="gpt3__footer section__padding gradient__bg">

      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <p>Powered By</p>
          <a href='https://www.nsmountains.com' target='blank'>
            <img src={gpt3Logo} alt="gpt3_logo" />
          </a>
        </div>

        <div className="gpt3__footer-links_div">
          <h4>Links</h4>
          <Link to="/professional-home-inspection-demo" onClick={() => window.scrollTo(0, 0)}>Home Inspection Demo</Link>
          <Link to="/blog" onClick={() => window.scrollTo(0, 0)}>Knowledge Center</Link>
          <Link to="/become-a-partner" onClick={() => window.scrollTo(0, 0)}>Become a SnagEasy Partner</Link>
          <Link to="/legal-property-services" onClick={() => window.scrollTo(0, 0)}>Legal</Link>
          <Link to="/home-inspection-faq" onClick={() => window.scrollTo(0, 0)}>FAQs</Link>
          <Link to="/home-inspection-pune" onClick={() => window.scrollTo(0, 0)}>Home Inspection in Pune</Link>
          <Link to="/home-inspection-mumbai" onClick={() => window.scrollTo(0, 0)}>Home Inspection in Mumbai</Link>
          <Link to="/home-inspection-bangalore" onClick={() => window.scrollTo(0, 0)}>Home Inspection in Bangalore</Link>
          <Link to="/home-inspection-chennai" onClick={() => window.scrollTo(0, 0)}>Home Inspection in Chennai</Link>
          <Link to="/home-inspection-tools" onClick={() => window.scrollTo(0, 0)}>Home Inspection Tools</Link>
          <Link to="/home-inspection-checklist" onClick={() => window.scrollTo(0, 0)}>Home Inspection Checklist</Link>
          <Link to="/home-inspection-inspector-app" onClick={() => window.scrollTo(0, 0)}>SnagEasy Home Inspector App</Link>
          <Link to="/common-hidden-defects-during-home-inspection" onClick={() => window.scrollTo(0, 0)}>Common Hidden Defects</Link>
          <Link to="/thermal-inspection" onClick={() => window.scrollTo(0, 0)}>Thermal Inspection</Link>
          <Link to="/home-inspection-lonavala" onClick={() => window.scrollTo(0, 0)}>Home Inspection in Lonavala</Link>
          
        </div>

        <div className="gpt3__footer-links_div">
          <h4>Company</h4>
          <Link to="/about-us" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
          <Link to="/careers" onClick={() => window.scrollTo(0, 0)}>Careers</Link>
          <p>
            <a href="https://www.nsmountains.com/royal-villa-block-work/2083/" target='blank'>
              Construction Site Work
            </a>
          </p>
          <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
        </div>

        <div className="gpt3__footer-links_div">
          <h4>Get in touch</h4>
          <div className="social-media-icons">
            <a href="https://www.facebook.com/nsmountains" target='blank'>
              <FacebookIcon style={{ fontSize: 30, color: 'var(--gradient-text)' }} />
            </a>
            <a href="https://www.instagram.com/ns_mountains" target='blank'>
              <InstagramIcon style={{ fontSize: 30, color: 'var(--gradient-text)' }} />
            </a>
            <a href="https://www.youtube.com/@NSMountains" target='blank'>
              <YouTubeIcon style={{ fontSize: 30, color: 'var(--gradient-text)' }} />
            </a>
            <a href="https://www.linkedin.com/company/n-s-mountains" target='blank'>
              <LinkedInIcon style={{ fontSize: 30, color: 'var(--gradient-text)' }} />
            </a>
          </div>
        </div>
      </div>

      {/* Trademark - styled one-line block */}
<div className="footer-trademark styled-one-line" role="note" aria-label="Trademark notice">
  <span className="tm-left">SNAGEASY<span className="reg">®</span></span>
  {/* <span className="tm-sep" aria-hidden="true">•</span> */}
  <span className="tm-right">Registered trademark of N S Mountains LLP (Reg. No. 5949934)</span>
</div>

      <div className="gpt3__footer-copyright">
        <p>@{currentYear} SnagEasy. All rights reserved.</p>
      </div>

    </div>
  );
};

export default Footer;